import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FiltroDto } from '../dto/util/filtro-dto';
import { ExpedienteFiltroDto } from '../dto/expediente/expediente.filtro.dto';
import { ExpedienteDto } from '../dto/expediente/expediente.dto';
import { PaginaDto } from '../dto/util/pagina-dto';
import { ExpedienteSuperfinancieraDto } from '../dto/expediente/expediente-superfinanciera.dto';
import { ExpedienteSupersociedadesDto } from '../dto/expediente/expediente-supersociedades.dto';
import { environment } from '../../environments/environment';
import { ExpedienteDndaDto } from '../dto/expediente/expediente-dnda.dto';
import { ExpedienteIcaDTO } from '../dto/expediente/expediente-ica.dto';
import { ExpedienteDimarDto } from '../dto/expediente/expediente-dimar.dto';
import { ExpedienteSicDto } from '../dto/expediente/expediente-sic.dto';
import { ExpedienteSupersaludDto } from '../dto/expediente/expediente-supersalud.dto';
import { ExpedienteSupersociedadesMercantilesDto } from '../dto/expediente/expediente-supersociedades-mercantiles.dto';
import {
  EstadoFinancieroSSIDTO,
  ExpedienteSSIDTO,
  HistoricoSSIDTO
} from "../modules/expediente/supersociedades-insolvencia/models/expedienteSSIDTO";
import { AnexoDTO } from '../dto/expediente/anexo.dto';
import { GenericResponseDto } from '../dto/util/generic-response.dto';
@Injectable({
  providedIn: 'root',
})
export class ExpedienteService {
  private apiUrl = `${environment.apiUrl}/expediente`;

  constructor(private http: HttpClient) {}

  getExpedientes(
    filtros: FiltroDto<ExpedienteFiltroDto>
  ): Observable<PaginaDto<ExpedienteDto>> {
    return this.http.post<PaginaDto<ExpedienteDto>>(
      `${this.apiUrl}/filtrar-memoria`,
      filtros
    );
  }

  getDocumentoPorConsecutivo(consecutivo: number): Observable<AnexoDTO> {
    return this.http.get<AnexoDTO>(`${this.apiUrl}/anexos/descargar/${consecutivo}`);
  }



  getExpedientesSuperfinanciera(
    idExpediente: number,
    tipoDocumento?: string,
    numeroidentificacion?: string
  ): Observable<ExpedienteSuperfinancieraDto> {
    return this.http.get<ExpedienteSuperfinancieraDto>(
      `${this.apiUrl}/superfinanciera/${idExpediente}/${tipoDocumento}/${numeroidentificacion}`
    );
  }

  getExpedientesSupersociedades(
    idExpediente: number,
    tipoDocumento?: string,
    numeroidentificacion?: string
  ): Observable<ExpedienteSupersociedadesDto> {
    return this.http.get<ExpedienteSupersociedadesDto>(
      `${this.apiUrl}/supersociedades/${idExpediente}/${tipoDocumento}/${numeroidentificacion}`
    );
  }

  getExpedientesDnda(idExpediente: number): Observable<ExpedienteDndaDto> {
    return this.http.get<ExpedienteDndaDto>(
      `${this.apiUrl}/dnda/${idExpediente}`
    );
  }

  getExpedientesIca(idExpediente: number): Observable<ExpedienteIcaDTO> {
    return this.http.get<ExpedienteIcaDTO>(
      `${this.apiUrl}/ica/${idExpediente}`
    );
  }

  getExpedienteDimar(expedienteId: number,tipoDocumento?: string,numeroidentificacion?: string): Observable<ExpedienteDimarDto> {
    return this.http.get<ExpedienteDimarDto>(
      `${this.apiUrl}/dimar/${expedienteId}/${tipoDocumento}/${numeroidentificacion}`
    );
  }

  getExpedienteSic(expedienteId: number, tipoDocumento?: string, numeroidentificacion?: string): Observable<ExpedienteSicDto> {
    return this.http.get<ExpedienteSicDto>(
      `${this.apiUrl}/sic/${expedienteId}/${tipoDocumento}/${numeroidentificacion}`
    );
  }

  getExpedienteSuperSalud(
    expedienteId: number,
    tipoDocumento?: string,
    numeroidentificacion?: string
  ): Observable<ExpedienteSupersaludDto> {
    return this.http.get<ExpedienteSupersaludDto>(
      `${this.apiUrl}/supersalud/${expedienteId}/${tipoDocumento}/${numeroidentificacion}`
    );
  }

  getExpedienteSupersociedadesMercantiles(
    expedienteId: number,
    tipoDocumento?: string,
    numeroidentificacion?: string
  ): Observable<ExpedienteSupersociedadesMercantilesDto> {
    return this.http.get<ExpedienteSupersociedadesMercantilesDto>(
      `${this.apiUrl}/supersociedades/${expedienteId}/${tipoDocumento}/${numeroidentificacion}`
    );
  }

  getExpedienteByProceso(
    entidadId: number,
    procesoId: string,
    esInsolvencia = false,
  ): Observable<ExpedienteDto> {
    return this.http.get<ExpedienteDto>(
      `${this.apiUrl}/${entidadId}/proceso/${procesoId}/${esInsolvencia}`
    );
  }

  getPermisoExpedienteUsuarioById(
    idUsuario: number,
    expedienteId: number,
    tipoUsuarioFuncional: number,
  ): Observable<GenericResponseDto> {
    return this.http.get<GenericResponseDto>(
      `${this.apiUrl}/tiene-permiso/${idUsuario}/${expedienteId}/${tipoUsuarioFuncional}`
    );
  }

  // Supersociedades de insolvencia
  expedienteSSI(id: number) {
    return this.http.get<ExpedienteSSIDTO[]>(
      `${this.apiUrl}/ssi/${id}`
    );
  }
  detalleSSI(id: number) {
    return this.http.get<HistoricoSSIDTO[]>(
      `${this.apiUrl}/detalle-ssi/${id}`
    );
  }
  estadoFinancieroSSI(id: number) {
    return this.http.get<EstadoFinancieroSSIDTO[]>(
      `${this.apiUrl}/estado-financiero-ssi/${id}`
    );
  }
  getEntidadById(id: number): Observable<{ id: number; Entidad: string }> {
  return this.http.get<{ id: number; Entidad: string }>(`${this.apiUrl}/entidad/${id}`);
}
}
